import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ContextProvider } from './context';
import ErrorBoundry from './components/error-boundry';
import AppContainer from './components/app';
import 'normalize.css';
import './scss/style.scss';

ReactDOM.render(
  <StrictMode>
      <ContextProvider>
        <ErrorBoundry>
          <Router>
            <AppContainer />
          </Router>
        </ErrorBoundry>
      </ContextProvider>
  </StrictMode>,
  document.getElementById('root')
);